import { messageDao } from '../dao/message-dao'
import { EventBusMessage } from '../util/event-bus-util'
import { logger } from '../util/logger'

export const messageService = {
  subscribeToEmailNotifications: (): void => {
    messageDao.setMyOptIn({ isOptingIn: true })
  },

  // TODO: email verification is done on the backend
  // We should use backend to notify messageMS that email is verified
  sendEmailVerified: (params: { message: EventBusMessage }): void => {
    const { message } = params
    const { email } = message.meta ?? {}

    if (!email) {
      logger.error('Unable to get verified email from EventBusMessage metadata')
      return
    }
    // TODO need to implement
  },
}
